export default __webpack_public_path__ + "static/media/Andriod-Tanjea-1.b3cb1025.png";